var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { HttpClient } from '@angular/common/http';
import { Environment } from '../../shared/environment/environment';
import { Observable, of } from 'rxjs';
import { flatMap, map, mergeMap } from 'rxjs/internal/operators';
import { CacheConstants } from '../../shared/cache-constants';
import { Cached } from '@ngx-cache/core';
import { MaintenancePropertyMapper } from './maintenance-property-mapper';
import { OcapiService } from '../ocapi/ocapi.service';
import { LocalApiService } from '../local-api/local-api.service';
var MaintenanceService = /** @class */ (function () {
    function MaintenanceService(httpClient, localApiService, maintancePropertyMapper, ocapiService) {
        this.httpClient = httpClient;
        this.localApiService = localApiService;
        this.maintancePropertyMapper = maintancePropertyMapper;
        this.ocapiService = ocapiService;
    }
    MaintenanceService.prototype.getMaintenanceMode = function () {
        var _this = this;
        return this.httpClient.get(this.getMaintenanceModePropertyUrl()).pipe(flatMap(function (response) {
            return _this.isCpeIdInMaintenance(response).pipe(map(function (bool) {
                if (response.enabled) {
                    response.enabled = bool;
                }
                return _this.maintancePropertyMapper.mapProperty(response);
            }));
        }));
    };
    MaintenanceService.prototype.getMaintenanceModePropertyUrl = function () {
        return Environment.environmentConfig().baseApiUrl + '/omapi/public/publicconfigs/planned_maintenance_eostvshop';
    };
    MaintenanceService.prototype.isCpeIdInMaintenance = function (maintenanceModeConfig) {
        var _this = this;
        return this.ocapiService.getCpeIdBehaviorSubject().pipe(mergeMap(function (cpeIdParam) {
            if (cpeIdParam) {
                return of(_this.containsCpeId(_this.getCpeIdsThatIgnoreMaintenanceMode(maintenanceModeConfig), cpeIdParam));
            }
            else {
                return _this.localApiService.getBoxCpeId().pipe(map(function (cpeid) {
                    return _this.containsCpeId(_this.getCpeIdsThatIgnoreMaintenanceMode(maintenanceModeConfig), cpeid);
                }));
            }
        }));
    };
    MaintenanceService.prototype.containsCpeId = function (ignoredCpeIds, cpeId) {
        return ignoredCpeIds.filter(function (ignoredCpeId) { return ignoredCpeId === cpeId; }).length === 0;
    };
    MaintenanceService.prototype.getCpeIdsThatIgnoreMaintenanceMode = function (maintenanceModeConfig) {
        return maintenanceModeConfig.value ? JSON.parse(maintenanceModeConfig.value).cpeids_that_ignore_maintenance_mode : [];
    };
    __decorate([
        Cached(CacheConstants.PLANNED_MAINTENANCE),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Observable)
    ], MaintenanceService.prototype, "getMaintenanceMode", null);
    return MaintenanceService;
}());
export { MaintenanceService };
